import { SVGProps } from 'react'

export const WpsFontColorSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M7.997 3.429L6.398 8h3.2L7.997 3.429zM8.497 2L12 12h-1L9.949 9h-3.9L5 12H4L7.496 2h1z'
        fillRule='evenodd'
      />
    </svg>
  )
}
